import {
    type AuctionItemEntity,
    type AuctionListingItemEntity,
    type DirectSaleItemEntity,
    type DirectSaleListingItemEntity,
    type AuctionNegotiationPlatformEntity,
    SaleType,
    SellingMethod,
} from '~/apiClient';

export type PlatformSellingMethod = Extract<SellingMethod, SellingMethod.Auction | SellingMethod.DirectSale>;

export type SaleListingItemEntity = AuctionListingItemEntity | DirectSaleListingItemEntity;

export type SaleItemEntity = AuctionItemEntity | DirectSaleItemEntity;

export enum SaleBundleType {
    Mono = SaleType.Mono,
    BundleMonoVersion = SaleType.BundleMonoVersion,
    BundleMultiVersion = SaleType.BundleMultiVersion,
}

export const SALE_BUNDLE_TYPE_TO_SALE_TYPE_ARRAY_MAP = {
    [SaleBundleType.Mono]: [SaleType.Mono, SaleType.MonoToScrap],
    [SaleBundleType.BundleMonoVersion]: [SaleType.BundleMonoVersion, SaleType.BundleMultiVersionToScrap],
    [SaleBundleType.BundleMultiVersion]: [SaleType.BundleMultiVersion, SaleType.BundleMultiVersionToScrap],
};

export function isAuction(sale: SaleItemEntity | SaleListingItemEntity): sale is AuctionItemEntity | AuctionListingItemEntity {
    return sale.sellingMethod === SellingMethod.Auction;
}

export function isDirectSale(sale: SaleItemEntity | SaleListingItemEntity): sale is DirectSaleListingItemEntity | DirectSaleItemEntity {
    return sale.sellingMethod === SellingMethod.DirectSale;
}

export function isSaleListingItemEntity(sale: SaleItemEntity | SaleListingItemEntity): sale is SaleListingItemEntity {
    return 'assetCount' in sale;
}

export interface AuctionItemEntityWithNegotiation extends Omit<AuctionItemEntity, 'negotiation'> {
    negotiation: AuctionNegotiationPlatformEntity;
}

export const isAuctionItemEntityWithNegotiation = (auction: AuctionItemEntity): auction is AuctionItemEntityWithNegotiation =>
    auction.negotiation !== null;
